// styled components
import { Button, Select, Form, Input, Radio, Table, Empty } from "antd";
// dataSelects
import {
  TipoDocumentosOptions,
  EtniaOptions,
  OrientacionSexualoOptions,
  IdentidadGeneroOptions,
} from "../../../../utils/dataSelectOptions";
// hooks
import { useAgregarParticipante } from "../../../../hooks/useAgregarParticipante";
// icons
import { LeftOutlined, RightOutlined, DeleteOutlined } from "@ant-design/icons";
import { Convocatoria } from "../../../../models/ConvocatoriasModel/convocatoria.model";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";

interface IProps {
  convocatorias?: Convocatoria;
}

export const FormAgregarParticipante = (props: IProps) => {
  const { subparticipante, setSubParticipante, subparticipantes, agregarFila, eliminarFila } = useAgregarParticipante();
  // form fields
  const fields = [
    { name: "numero_documento", value: subparticipante.numero_documento },
    { name: "tipo_identificacion", value: subparticipante.tipo_identificacion },
    { name: "primer_nombre", value: subparticipante.primer_nombre },
    { name: "segundo_nombre", value: subparticipante.segundo_nombre },
    { name: "primer_apellido", value: subparticipante.primer_apellido },
    { name: "segundo_apellido", value: subparticipante.segundo_apellido },
    { name: "orientacion_sexual", value: subparticipante.orientacion_sexual },
    { name: "identidad", value: subparticipante.identidad },
    { name: "grupo_etnico", value: subparticipante.grupo_etnico },
    { name: "rango_edad", value: subparticipante.rango_edad },
    { name: "rol", value: subparticipante.rol },
  ];
  // columns
  const columns = [
    {
      title: "Número de documento",
      width: 60,
      dataIndex: "numero_documento",
      key: "numero_documento",
    },
    {
      title: "Nombre",
      width: 200,
      render: (datos: any) => (
          <span>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido} {datos.segundo_apellido}{" "}
          </span>
      ),
    },
    {
      title: "Rol",
      width: 100,
      dataIndex: "rol",
      key: "rol",
    },
    {
      title: "Acciones",
      width: 60,
      render: (datos: any, datos2: any, index: number) => (
        <Button
          className="button-azul-ghost"
          icon={<DeleteOutlined />}
          onClick={() => eliminarFila(index, datos.numero_documento)}
        />
      ),
    },
  ];
  // pagination table
  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  };
  return (
    <div>
      <Form
        name="basic"
        size="large"
        layout="vertical"
        onFinish={agregarFila}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...subparticipante };
          console.log(fields);
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setSubParticipante(infoupdate);
        }}
      >
        <div className="mt-4">
          <div className="row">
            <div className="col-12">
              {!props.convocatorias?.menor_edad &&
                <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828">
                  *Recuerda que los participantes deben ser mayores de 14 años edad
                </span>
              }
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Tipo de documento"
                name="tipo_identificacion"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="C.C.">
                  {TipoDocumentosOptions.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Número de documento"
                name="numero_documento"
                rules={[
                  { required: true, message: "Campo obligatorio" },
                  { max: 10, message: "Máximo 10 números" },
                  { min: 7, message: "Mínimo 7 números" }
                ]}
              >
                <Input style={{ width: "100%" }} placeholder="No." />
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Primer nombre"
                name="primer_nombre"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputTexto maxLength={100} name="primer_nombre" texto={subparticipante.primer_nombre} setTexto={setSubParticipante} alltexto={subparticipante} onInput={subparticipante.primer_nombre} />
                {/* <Input style={{ width: "100%" }} /> */}
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label={
                  <>
                    Segundo nombre{" "}
                    <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                      {" "}
                      - Opcional
                    </span>
                  </>
                }
                name="segundo_nombre"
              // rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputTexto maxLength={100} name="segundo_nombre" texto={subparticipante.segundo_nombre} setTexto={setSubParticipante} alltexto={subparticipante} onInput={subparticipante.segundo_nombre} />
                {/* <Input style={{ width: "100%" }} /> */}
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Primer apellido"
                name="primer_apellido"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputTexto maxLength={100} name="primer_apellido" texto={subparticipante.primer_apellido} setTexto={setSubParticipante} alltexto={subparticipante} onInput={subparticipante.primer_apellido} />
                {/* <Input style={{ width: "100%" }} /> */}
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label={
                  <>
                    Segundo apellido{" "}
                    <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                      {" "}
                      - Opcional
                    </span>
                  </>
                }
                name="segundo_apellido"
              // rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <InputTexto maxLength={100} name="segundo_apellido" texto={subparticipante.segundo_apellido} setTexto={setSubParticipante} alltexto={subparticipante} onInput={subparticipante.segundo_apellido} />
                {/* <Input style={{ width: "100%" }} /> */}
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Rango de edad"
                name="rango_edad"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="Selecciona un rango de edad...">
                  <Select.Option value="14 - 18">
                    14 - 18 años
                  </Select.Option>
                  <Select.Option value="18 - 22">
                    18 - 22 años
                  </Select.Option>
                  <Select.Option value="22 - 30">
                    22 - 30 años
                  </Select.Option>
                  <Select.Option value="30 - 40">
                    30 - 40 años
                  </Select.Option>
                  <Select.Option value="40 - 50">
                    40 - 50 años
                  </Select.Option>
                  <Select.Option value="50 - 60">
                    50 - 60 años
                  </Select.Option>
                  <Select.Option value="60 - 70">
                    60 - 70 años
                  </Select.Option>
                  <Select.Option value="70 - 80">
                    70 - 80 años 
                  </Select.Option>
                  <Select.Option value="80 - 90">
                    80 - 90 años
                  </Select.Option>
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Rol que desempeña"
                name="rol"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Input maxLength={30} style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label={
                  <>
                    Orientación sexual{" "}
                    <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                      {" "}
                      - Opcional
                    </span>
                  </>
                }
                name="orientacion_sexual"
              // rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="C.C.">
                  {OrientacionSexualoOptions.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label="Grupo étnico"
                name="grupo_etnico"
                rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="C.C.">
                  {EtniaOptions.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                className="no-margin"
                label={
                  <>
                    Identidad de género{" "}
                    <span className="font-family-Montserrat-Regular font-size-10px font-color-707070">
                      {" "}
                      - Opcional
                    </span>
                  </>
                }
                name="identidad"
              // rules={[{ required: true, message: "Campo obligatorio" }]}
              >
                <Select style={{ width: "100%" }} placeholder="C.C.">
                  {IdentidadGeneroOptions.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {!props.convocatorias?.menor_edad &&
              <div className="col-12 col-md-4">
                <Form.Item
                  className="no-margin"
                  label="Mayor de edad"
                  name="mayor_edad"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Radio.Group>
                    <Radio value={true}>Sí</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            }
            <div className="justify-content-flex-end">
              <Button className="button-azul-radius font-size-12px" htmlType="submit">
                Agregar
              </Button>
            </div>
            <div className="col-12">
              <span className="font-size-12px font-family-Montserrat-SemiBold" style={{ paddingBottom: "16px" }}>
                Participantes
              </span>
              <Table
                size="small"
                style={{ borderTop: "1px solid #C4C4C4", marginTop: "16px" }}
                className="table-ant-design-modify font-size-12px"
                bordered={false}
                columns={columns}
                dataSource={subparticipantes}
                locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, hideOnSinglePage: true }}
              />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
